import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';

const limitExceedImg = require('../../../glyphs/error-limitExceed.svg');

const mapStateToProps = state => ({
  apiError: state.Manage.apiError,
  country: state.LanguageBundle.country,
  language: state.Manage.language,
  storefront: state.Manage.storefront,
});

class ErrorPaymentLimitExceed extends Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
    };

    this.handleBtnToE4Home = this.handleBtnToE4Home.bind(this);
  }

  render() {
    return (
      <div className='ErrorModal'>
        <div className='Modal-Baggage'>
          <div className='Modal-Baggage__container'>
            { this.renderError() }
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    return (
      <div className='ErrorRetryModal--limitExceedTwo'>
        <div className='ErrorRetryModal-main--limitExceed'>
          <div className='ErrorRetryModal-contenedorImg--limitExceed'>
            <img
              alt='Limit-Exceed'
              className='ErrorRetryModal-imgError--limitExceed'
              src={ limitExceedImg } />
          </div>
          <TranslatedCopy
            className='ErrorRetryModal-body--limitExceedTwo'
            copyID='MYB_PAYMENT_ERROR_DECLINED_PAYMENT'
            tagName='p' />
          <TranslatedCopy
            className='ErrorRetryModal-heading--limitExceedThree'
            copyID='MYB_PAYMET_ERROR_LIMIT_EXCEED'
            tagName='h5' />
          <TranslatedCopy
            className='ErrorRetryModal-body--limitExceedError'
            copyID='MYB_PAYMENT_ERROR_RETRY_NEW_BOOKING'
            tagName='p' />
        </div>
        <div className='ModalCta--limitExceed'>
          <div className='ErrorRetryModal-wrapActions'>
            <div className='Form-submit EmailPNRInfo-saveButton'>
              <Btn
                className='ErrorRetryModal-accept--limitExceed'
                onBtnClick={ this.handleBtnToE4Home }
                filledRed={ true }
                copyID='MYB_PAYMENT_ERROR_BUTTON_RETRY' />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // DeepLink para Home E4
  handleBtnToE4Home() {
    const { country, language } = this.props;
    window.location = `https://${location.host}/${language}-${country}`;
  }
}

ErrorPaymentLimitExceed = connect(mapStateToProps)(ErrorPaymentLimitExceed);

export default ErrorPaymentLimitExceed;